import { skipToken } from '@tanstack/react-query';

import { CustomError } from './normalizeServerRequest';

export type NotSkipTokenOptions<T extends Record<string, any>> = Exclude<
  T,
  'queryFn'
> & {
  queryFn: Exclude<T['queryFn'], typeof skipToken>;
};

export const preventSkipToken = <T extends Record<string, any>>(options: T) => {
  if (!options.queryFn || typeof options.queryFn === typeof skipToken) {
    throw new CustomError({
      return_message: 'skipToken 사용 불가',
    });
  }

  return options as NotSkipTokenOptions<T>;
};
